var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleMaps = function SvgGoogleMaps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A73E8",
    d: "M14.364 1.664a7.39 7.39 0 0 0-2.23-.344A7.366 7.366 0 0 0 6.48 3.957l3.488 2.935z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M6.479 3.957a7.353 7.353 0 0 0-1.73 4.746c0 1.388.277 2.513.731 3.521l4.487-5.333z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M12.133 5.88a2.824 2.824 0 0 1 2.157 4.647L18.685 5.3a7.398 7.398 0 0 0-4.32-3.637L9.967 6.891a2.816 2.816 0 0 1 2.166-1.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M12.133 11.526a2.824 2.824 0 0 1-2.166-4.637L5.48 12.223c.767 1.7 2.042 3.066 3.356 4.786l5.453-6.484c-.517.612-1.292 1-2.156 1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M14.18 18.78c2.463-3.852 5.335-5.6 5.335-10.078 0-1.227-.3-2.384-.83-3.401L8.837 17.01c.418.547.838 1.13 1.25 1.77 1.497 2.314 1.081 3.702 2.047 3.702.964 0 .55-1.39 2.047-3.703"
  })));
};
export default SvgGoogleMaps;